<template>
  <PopulationTabActions
    ref="populationTabActionsRef"
    :is-action-bar-disabled="isActionBarDisabled"
    :show-edit-button="hasEditPermission"
    :event-site="eventSite"
    search-placeholder="Search partners"
    :first-filter="partnerTagFilter"
    :initial-filter-keys="['partner_tag', 'sharing_level', 'field_presets']"
    :feed-id="feedId"
    :source-id="sourceId"
    :has-custom-field-selection-option="hasCustomFieldSelections"
    @search-applied="emit('search-applied', $event)"
    @filters-applied="emit('filters-applied', $event)"
    @edit-clicked="emit('edit-clicked')"
  />
</template>

<script setup lang="ts">
import { BittsIcon } from '@crossbeam/bitts/src/types';

import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';

import { usePartnersStore } from '@/stores';

import PopulationTabActions from './PopulationTabActions.vue';

type FilterValues = Record<string, (string | number)[]>;

withDefaults(
  defineProps<{
    isActionBarDisabled?: boolean;
    hasEditPermission?: boolean;
    feedId?: number;
    sourceId?: number;
    hasCustomFieldSelections?: boolean;
    /** Event site for dataSharingAction (e.g. default sharing single population). */
    eventSite?: string;
  }>(),
  {
    isActionBarDisabled: false,
    hasEditPermission: true,
    feedId: undefined,
    sourceId: undefined,
    hasCustomFieldSelections: false,
    eventSite: undefined,
  },
);

const emit = defineEmits<{
  'search-applied': [value: string];
  'filters-applied': [filterValues: FilterValues];
  'edit-clicked': [];
}>();

const { partnerTags } = storeToRefs(usePartnersStore());

const partnerTagFilter = computed(() => ({
  value: 'partner_tag',
  options: partnerTags.value.map((tag) => ({
    label: tag.label,
    value: tag.id as string,
  })),
  label: 'Partner Tag',
  faIcon: ['fak', 'tag'] as BittsIcon,
}));

const populationTabActionsRef = ref<InstanceType<
  typeof PopulationTabActions
> | null>(null);

function clearAllFilters() {
  populationTabActionsRef.value?.clearAllFilters();
}

defineExpose({
  clearAllFilters,
});
</script>
